import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import { AWSIoTProvider, PubSub } from "@aws-amplify/pubsub";
import { AstraAwsConfig } from "./STConfig"

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

PubSub.addPluggable(
  new AWSIoTProvider({
    aws_pubsub_region: AstraAwsConfig.REGION,
    aws_pubsub_endpoint:
      AstraAwsConfig.AWS_IOT_WS_ENDPOINT
  })
);

Amplify.configure(awsExports);
